/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';
import { DialogDefaultV2 } from '../../../components/v2';

const InvalidarDialog = ({ open, onClose, onConfirm }) => (
  <DialogDefaultV2
    open={open}
    handlerCancel={onClose}
    handlerConfirm={onConfirm}
    title="Invalidar nota"
    confirmMessage="Confirmar"
    cancelMessage="Cancelar"
    maxWidth="sm"
    fullWidth
    useFullScreen={false}
  >
    <Typography variant="body2" color="text.secondary">
      Deseja invalidar esta nota? Esta ação altera o status da nota conforme as regras do sistema.
    </Typography>
  </DialogDefaultV2>
);

InvalidarDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default InvalidarDialog;
